export default __webpack_public_path__ + "static/media/sponsor_2.334b90cd.png";